// Browser-storage keys that hold user-authored / user-scoped content.
//
// Collected here (rather than as string literals at each call site) so that
// sign-out has a single, auditable list of what must be wiped from the
// device. See B-new-84: the customer-service chatbot persists whole
// conversations to localStorage, and sign-out used to leave them behind for
// the next person to use the machine.

/** Conversation transcript of the global customer-service chatbot widget. */
export const CHATBOT_MESSAGES_STORAGE_KEY = 'customer-chatbot-messages'

/**
 * Every localStorage key that belongs to the signed-in person rather than to
 * the browser/device. Deliberately excludes device preferences (theme,
 * locale, dismissal flags) — those are not personal data and wiping them
 * would be a hostile UX for the shared-machine case this exists to protect.
 */
export const USER_SCOPED_STORAGE_KEYS = [CHATBOT_MESSAGES_STORAGE_KEY] as const

/**
 * Best-effort wipe of user-authored local state. Never throws: storage can be
 * unavailable (Safari private mode, quota, disabled cookies) and a failure
 * here must not block or corrupt the sign-out flow.
 */
export function clearUserScopedStorage(): void {
  for (const key of USER_SCOPED_STORAGE_KEYS) {
    try {
      window.localStorage.removeItem(key)
    } catch {
      // ignore — nothing actionable, and sign-out must continue
    }
  }
}
